module.exports = __webpack_public_path__ + "img/active_options.def5227f.svg";